function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmallArrowLeft(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m50.032 62.659a4.0678 4.0678 0 0 0 0-6.464l-25.101-20.963a4.1318 4.1318 0 0 1 0-6.464l25.101-20.963a4.0678 4.0678 0 0 0 0-6.464 6.2664 6.2664 0 0 0-7.7483 0l-25.101 20.959a12.178 12.178 0 0 0 0 19.396l25.108 20.963a6.2664 6.2664 0 0 0 7.7483 0z",
    fill: "currentColor",
    style: {
      strokeWidth: 1.9371
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallArrowLeft);
export default __webpack_public_path__ + "static/media/small-arrow-left.666d1d3c.svg";
export { ForwardRef as ReactComponent };